import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

// Replaces @angular/flex-layout's responsive `ngClass.<breakpoint>` (GX-7106).
// Uses flex-layout v10's media queries and priority order: when several breakpoints match,
// the highest-priority one that has classes wins; with none matching, the classes are removed.
// Usage: <div [appBreakpointClass]="{'xs': 'mt-1', 'gt-sm': 'px-2 m-0'}">
const BREAKPOINTS = [
  { alias: 'xs', query: 'screen and (min-width: 0px) and (max-width: 599.9px)' },
  { alias: 'lt-sm', query: 'screen and (max-width: 599.9px)' },
  { alias: 'sm', query: 'screen and (min-width: 600px) and (max-width: 959.9px)' },
  { alias: 'lt-md', query: 'screen and (max-width: 959.9px)' },
  { alias: 'md', query: 'screen and (min-width: 960px) and (max-width: 1279.9px)' },
  { alias: 'lt-lg', query: 'screen and (max-width: 1279.9px)' },
  { alias: 'lg', query: 'screen and (min-width: 1280px) and (max-width: 1919.9px)' },
  { alias: 'lt-xl', query: 'screen and (max-width: 1919.9px)' },
  { alias: 'xl', query: 'screen and (min-width: 1920px) and (max-width: 4999.9px)' },
  { alias: 'gt-lg', query: 'screen and (min-width: 1920px)' },
  { alias: 'gt-md', query: 'screen and (min-width: 1280px)' },
  { alias: 'gt-sm', query: 'screen and (min-width: 960px)' },
  { alias: 'gt-xs', query: 'screen and (min-width: 600px)' },
];

@Directive({
    selector: '[appBreakpointClass]',
    standalone: false
})
export class BreakpointClassDirective implements OnInit, OnDestroy {
  @Input() appBreakpointClass: { [alias: string]: string } = {};
  private applied: string[] = [];
  private subscription: Subscription;

  constructor(private elementRef: ElementRef, private renderer: Renderer2, private breakpointObserver: BreakpointObserver) { }

  ngOnInit() {
    this.subscription = this.breakpointObserver.observe(BREAKPOINTS.map(bp => bp.query)).subscribe(state => {
      const active = BREAKPOINTS.find(bp => state.breakpoints[bp.query] && this.appBreakpointClass[bp.alias] !== undefined);
      this.applied.forEach(c => this.renderer.removeClass(this.elementRef.nativeElement, c));
      this.applied = active ? this.appBreakpointClass[active.alias].split(' ').filter(c => c) : [];
      this.applied.forEach(c => this.renderer.addClass(this.elementRef.nativeElement, c));
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
